// assets/ud-card-moods.js
// Simon 2026-10-06: one small line "Calm · Social Buzz" on the collection cards of the ~120
// functional drinks, so a customer sees WHY a drink sits in a mood (option 2 of the mock-ups).
// Moods come from assets/ud-card-moods.json, rebuilt every morning by
// 1_upside-drinks/tools/nutrition-facts/scripts/mood_cards.mjs from the mood-* tags.
// Globo renders the cards client-side, so we watch the DOM like upside-unit-price.js does.
(function () {
  'use strict';
  if (window.__UD_CARD_MOODS__) return;
  window.__UD_CARD_MOODS__ = true;

  var me = document.currentScript;
  var URL_JSON = me && me.getAttribute('data-moods');
  if (!URL_JSON) return;
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  // Simon 2026-10-08: moods only where people shop by mood (Wellness + the 6 mood pages = templates
  // collection.wellness-*). Everywhere else (shop all, beer, search...) one green "Better-for-you" badge.
  var WELLNESS = me.getAttribute('data-wellness') === '1';
  var BFY = ['#e7f6ec', '#1c7c3c'];
  var BFY_LABEL = FR ? 'Mieux-être' : 'Better-for-you';
  var LABEL = FR
    ? { calm: 'Calme', 'wind-down': 'Soirée', focus: 'Concentration', energy: 'Énergie', gut: 'Intestin', social: 'Buzz social' }
    : { calm: 'Calm', 'wind-down': 'Wind Down', focus: 'Focus', energy: 'Energy', gut: 'Gut & Body', social: 'Social Buzz' };
  var moods = null;

  var st = document.createElement('style');
  // Simon 2026-10-07: the mood is a soft pastel pill on the photo (where the theme puts NEW), in the
  // colour of its "Shop by mood" bubble, with the same icon. Not part of the product name.
  var STYLE = {
    calm: ['#E3F0EA', '#2F6B52'], 'wind-down': ['#E9E5F5', '#5B4B8A'], focus: ['#E4EAF8', '#37446E'],
    energy: ['#FDF0D3', '#8A5A00'], gut: ['#E2F2EC', '#2F6B52'], social: ['#FBE4DF', '#9A3B2C']
  };
  var ICON = {
    calm: '<path d="M24 40c-9-4-14-11-14-20 7 0 11 3 14 8 3-5 7-8 14-8 0 9-5 16-14 20z"/><path d="M24 40V28"/>',
    'wind-down': '<path d="M34 31A14 14 0 0 1 19 9a14 14 0 1 0 15 22z"/><path d="M34 10v6M31 13h6"/>',
    focus: '<circle cx="24" cy="24" r="15"/><circle cx="24" cy="24" r="8"/>',
    energy: '<path d="M27 6 12 27h11l-3 15 16-22H25l2-14z"/>',
    gut: '<path d="M24 40V22"/><path d="M24 24c0-7-5-11-12-11 0 7 5 11 12 11z"/><path d="M24 30c0-7 5-11 12-11 0 7-5 11-12 11z"/>',
    social: '<path d="M10 10h12l-1 9a5 5 0 0 1-10 0l-1-9z"/><path d="M16 24v12M11 36h10"/><path d="M26 14h12l-1 9a5 5 0 0 1-10 0l-1-9z"/><path d="M32 28v10M27 38h10"/>'
  };
  st.textContent = '.grid-product__tag.ud-mood-tag{display:inline-flex !important;align-items:center;gap:4px;border-radius:999px !important;' +
    'text-transform:none !important;letter-spacing:0 !important;font:700 11.5px/1 Montserrat,sans-serif !important;padding:5px 9px 5px 7px !important;' +
    'margin:6px 0 6px 0 !important;box-shadow:0 1px 3px rgba(0,0,0,.08)}' +
    '.grid-product__tag.ud-mood-tag svg{display:block;width:13px;height:13px;flex:0 0 auto;position:relative;top:-1px}' +
    // Simon 2026-10-09: SALE and Better-for-you overlapped. One stack bottom-left, 6px between labels,
    // at most 2 labels per card (theme labels like SALE / Price drop / Sold out come first in the DOM).
    '.grid-product__tags>.grid-product__tag:nth-child(n+3){display:none !important}';
  document.head.appendChild(st);

  function doCard(card) {
    if (card.querySelector('.ud-mood-tag')) return;
    var m = moods[card.getAttribute('data-product-handle')];
    if (!m || !m.length) return;
    var tags = card.querySelector('.grid-product__tags');
    if (!tags) {
      var wrap = card.querySelector('.grid-product__image-wrap'); if (!wrap) return;
      tags = document.createElement('div'); tags.className = 'grid-product__tags'; wrap.appendChild(tags);
    }
    var el = document.createElement('div');
    var k = m[0], s = WELLNESS ? (STYLE[k] || STYLE.calm) : BFY;
    el.className = 'grid-product__tag grid-product__tag--custom ud-mood-tag';
    el.style.cssText = 'background:' + s[0] + ' !important;color:' + s[1] + ' !important';
    el.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (WELLNESS ? (ICON[k] || '') : ICON.calm) + '</svg>';
    el.appendChild(document.createTextNode(WELLNESS ? (LABEL[k] || '') : BFY_LABEL));
    tags.appendChild(el);
  }
  function scan() {
    var cards = document.querySelectorAll('.grid-product[data-product-handle]');
    for (var i = 0; i < cards.length; i++) { try { doCard(cards[i]); } catch (e) {} }
  }
  function start() {
    scan();
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; scan(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  fetch(URL_JSON).then(function (r) { return r.json(); }).then(function (d) {
    moods = d;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }).catch(function () {});
})();
